import React, { useEffect, useRef, useContext } from "react";
import * as S from "./AdjustVolumeStyle";
import textData from "./data";
import Sound from "../../sounds/test.mp3";
import SoundImage from "../../sounds/testImageFile.wav";
import ButtonsGroup from "../ButtonsGroup/ButtonsGroup";
import { AppContext } from "../../AppContext";

const AdjustVolume = (props) => {
  const { data, addVolume } = useContext(AppContext);

  const audioElement = useRef(null);

  useEffect(() => {
    setPlayer();
  }, []);

  const setPlayer = () => {
    const player = audioElement.current;
    player.volume = 0.5;
    if (data.listeningDevice === "headphones") setStereoPlay();
    else player.loop = true;
  };

  const setStereoPlay = () => {
    // const player = audioElement.current;
    const player = document.getElementById("testAudio");
    const audioContext = new AudioContext();
    const gainNode = audioContext.createGain();
    const track = audioContext.createMediaElementSource(player);
    const pannerOptions = { pan: -1 };
    const panner = new StereoPannerNode(audioContext, pannerOptions);
    track.connect(gainNode).connect(panner).connect(audioContext.destination);

    player.addEventListener(
      "ended",
      () => {
        panner.pan.value = panner.pan.value * -1;
        player.play();
      },
      false
    );
  };

  const setVolume = (event) => {
    const player = audioElement.current;
    const soundPower = event.target.value / 100;
    addVolume(soundPower);
    return (player.volume = soundPower);
  };

  const onForwardBtnClick = () => {
    props.onForwardBtnClick();
  };

  return (
    <S.Container>
      <audio
        ref={audioElement}
        preload={"none"}
        autoPlay
        id="testAudio"
        src={data.isImageTest ? SoundImage : Sound}
      >
        {textData.alert}
      </audio>

      <S.Text>{textData.text}</S.Text>

      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={data.volume * 100}
        onChange={setVolume}
      />

      <ButtonsGroup
        onForwardBtnClick={onForwardBtnClick}
        onBackBtnClick={props.onBackBtnClick}
      />
    </S.Container>
  );
};

export default AdjustVolume;
